/**
 * Sign-in links into the interactive demo / API guide (demo.passiolife.com).
 *
 * The demo signs the customer in with their API key, which travels in the
 * fragment: fragments are never sent to a server, so the key stays out of load
 * balancer logs and Referer headers. The demo strips it from the address bar and
 * history before rendering, then signs in through `POST /api/auth/key`.
 *
 * Keys are per environment, so dev keys must go to the dev demo and prod keys
 * to the prod demo. Build the URL on click rather than rendering it into the
 * page, and never put it in an email or chat: anyone with the link has the key.
 */

export const DEMO_DEV_BASE_URL = "https://demo.cloud.passiolife.com";
export const DEMO_PROD_BASE_URL = "https://demo.passiolife.com";

/** Demo app path to open. Anything outside the app (or `/admin`) is ignored. */
export type DemoPage = "/tour" | "/photo" | "/developers" | `/${string}`;

export const resolveDemoBaseUrl = (isDevEnv: boolean): string => {
  const configured = String(process.env.REACT_APP_DEMO_BASE_URL || "")
    .trim()
    .replace(/\/+$/, "");
  return configured || (isDevEnv ? DEMO_DEV_BASE_URL : DEMO_PROD_BASE_URL);
};

export const buildDemoSignInUrl = (
  baseUrl: string,
  apiKey: string,
  page: DemoPage = "/tour"
): string => {
  const fragment = new URLSearchParams({ key: apiKey.trim(), to: page });
  return `${baseUrl}/#${fragment.toString()}`;
};

export const openDemoGuide = (
  baseUrl: string,
  apiKey: string,
  page: DemoPage = "/tour"
): void => {
  window.open(
    buildDemoSignInUrl(baseUrl, apiKey, page),
    "_blank",
    "noopener,noreferrer"
  );
};
